import moment from "moment";

export const pressureFormatter = (params) => {
  const hasSuperscriptChar = (value, char) => {
    return typeof value === "string" && value.includes(char);
  };
  const hasSuperscriptA = hasSuperscriptChar(params.value, "ᵃ");
  const hasSuperscriptB = hasSuperscriptChar(params.value, "ᵇ");

  const numericValue =
    hasSuperscriptA || hasSuperscriptB
      ? parseFloat(params.value.replace("ᵃ", "").replace("ᵇ", "").trim())
      : parseFloat(params.value);

  if (isNaN(numericValue)) {
    return "*";
  } else if (numericValue < 0) {
    return hasSuperscriptA ? "< 0 ᵃ" : hasSuperscriptB ? "< 0 ᵇ" : "< 0";
  } else if (numericValue > 100) {
    return hasSuperscriptA ? "> 100 ᵃ" : hasSuperscriptB ? "> 100 ᵇ" : "> 100";
  } else {
    return (Math.floor(numericValue * 10) / 10).toFixed(1);
  }
};
export const multipleReasonFormatter = (type) => {
  if (typeof type === "string") {
    type = type.split(",");
  }
  if (Array.isArray(type)) {
    const formattedType = type.map((item) => {
      const trimmedItem = item.trim();
      return trimmedItem;
    });
    const resultString = formattedType.join(", ");
    return resultString;
  }
  return type;
};

export const dateFormatter = (params) => {
  return params.value ? moment(params.value).format("DD/MM/YYYY") : "-";
};

export const typeFormatter = (params, t) => {
  if (!params.value) {
    return "";
  }
  return params.value?.toLowerCase() === "c" ||
    params.value?.toLowerCase() === "cip"
    ? t("foulingStrings.cip")
    : t("foulingStrings.shutdown");
};

export const sourceFormatter = (params, t) => {
  return params.data.is_tool_identified === true
    ? t("IdentifiedCIPStrings.calculation")
    : t("IdentifiedCIPStrings.user");
};

function splitLastOccurrence(str, substring) {
  if (str) {
    const lastIndex = str.lastIndexOf(substring);
    const before = str.slice(0, lastIndex);
    return before;
  } else {
    return str;
  }
}
export const timeFormatter = (params) => {
  if (!params.value) return "";
  const utcDate = new Date(params.value);
  // Get IST offset in minutes (5 hours 30 minutes = 330 minutes)
  const istOffset = 330;
  const istDate = new Date(utcDate.getTime() + istOffset * 60000);
  // Format as needed, e.g., YYYY-MM-DD HH:mm:ss
  return istDate.toLocaleString("en-IN", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
    timeZone: "Asia/Kolkata",
  });
};

export const dateComparator = (date1, date2) => {
  const date1Updated = splitLastOccurrence(date1, " ");
  const date2Updated = splitLastOccurrence(date2, " ");
  const d1 = new Date(date1Updated);
  const d2 = new Date(date2Updated);
  if (d1 > d2) {
    return -1;
  } else if (d1 < d2) {
    return 1;
  } else {
    return 0;
  }
};

export const getSortedData = (unsortedData) => {
  const data = [...unsortedData].sort((a, b) => {
    if (!a.start_date && !b.start_date) {
      return 0;
    } else if (!a.start_date) {
      return 1;
    } else if (!b.start_date) {
      return -1;
    } else {
      return new Date(a.start_date) - new Date(b.start_date);
    }
  });

  //console.log("Data is ", data);

  return data;
};

const getLanguageCode = {
  USD: {
    code: "en-US",
    currency: "USD",
    symbol: "$",
  },
  Yuan: {
    code: "zh-CN",
    currency: "CNY",
    symbol: "元",
  },
  Euro: {
    code: "EUR",
    currency: "EUR",
    symbol: "€",
  },
};

// imports are not supported in workers, so this function is duplicated in dataDownloaderWorker.js
// unable to pass function as parameter to worker
export const formattedCurrencyValue = (value, currency) => {
  const languageCurrency = getLanguageCode[currency].currency;
  const currencySymbol = getLanguageCode[currency].symbol;
  const currencyCode = getLanguageCode[currency].code;
  const isChineseCurrency = currencyCode === "zh-CN";

  if (!value) {
    return isChineseCurrency
      ? `${value}${currencySymbol}`
      : `${currencySymbol}${value}`;
  }

  let formattedValue = parseFloat(value).toLocaleString(currencyCode, {
    style: "currency",
    currency: languageCurrency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  if (isChineseCurrency) {
    // Move symbol from start to end: ¥123.45 -> 123.45¥ or -¥123.45 -> -123.45¥
    const symbolChar = formattedValue.charAt(value > 0 ? 0 : 1);
    formattedValue =
      value > 0
        ? formattedValue.slice(1) + symbolChar
        : formattedValue.charAt(0) + formattedValue.slice(2) + symbolChar;
    // Replace ¥ with 元
    formattedValue = formattedValue.replace("¥", "元");
  }

  return formattedValue;
};

export const twoDecimalFormatter = (params) => {
  if (params.value == null) {
    return "-";
  }
  return parseFloat(params.value).toFixed(2);
};

export const cipTypeFormatter = (params, t) => {
  const cipType = params.data.cip_type?.toLowerCase();
  if (!cipType) return "-";

  const translationKey = `HistoricCipTableStrings.${cipType}`;
  return t(translationKey) || params.data.cip_type;
};
